<template>
  <v-dialog
    :value="show"
    @input="updateShow"
    width="500"
    class="rounded-xl"
    @click:outside="close"
  >
    <v-card class="pa-5">
      <v-card-actions class="modal-header">
        User Preview
        <v-btn icon color="red" @click="close">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      
      <div v-if="item">
        <div class="author-container">
          <img
            v-if="item.photoURL"
            :src="item.photoURL"
            class="author-image"
            alt=""
            @error="handleImageError"
          />
          <v-avatar v-else size="64" class="author-image">
            <v-img
              :src="defaultAvatar"
              alt="Default Avatar"
              @error="handleImageError"
            />
          </v-avatar>
          <span class="author-name">{{ getUserName(item) }}</span>
          <img
            :src="openIcon"
            alt=""
            class="open-chart-button"
            @click="goToUserDetails"
          />
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">ID:</span> {{ item.uid }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Name:</span> {{ item.firstName }}
          {{ item.lastName }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Nickname:</span> {{ item.nickname }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Email:</span> {{ item.email }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Creation Date:</span>
          {{
            item.creationTime
              ? item.creationTime.toDate().toLocaleDateString()
              : ""
          }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Last login:</span>
          {{
            typeof item.lastLogin === "string"
              ? item.lastLogin
              : item.lastLogin
              ? item.lastLogin.toDate().toLocaleDateString()
              : ""
          }}
        </div>
        <div class="secondary--text">
          <span class="font-weight-light">Privilege:</span>
          {{ verifyPrivilege() }}
        </div>
      </div>

      <v-btn
        color="primary"
        text
        @click="copyUserData"
        class="copy-button my-4"
        style="background-color: #f5f5f5"
      >
        <v-icon left>mdi-content-copy</v-icon>
        Copy Raw Data
      </v-btn>

      <div v-if="events.length > 0 && loading === false">
        <h3 class="mb-4">Last 10 events</h3>
        <event-row v-for="event in events" :key="event.id" :item="event" />
      </div>

      <div v-if="loading" class="loading">
        <v-progress-circular size="64" width="4" color="red" indeterminate />
      </div>

      <!-- <v-card-text>
        {{ JSON.stringify(item) }}
      </v-card-text> -->
      <!-- <post-detail v-else :item="postData" /> -->
    </v-card>
  </v-dialog>
</template>

<script>
import EventRow from "../events/EventRow.vue";

export default {
  components: { EventRow },
  name: "user-preview-modal",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    item: {
      type: Object,
      required: false,
      default: () => null,
      validator: function (value) {
        return value === null || typeof value === "object";
      },
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      defaultAvatar: require("@/assets/default-avatar.png"),
      openIcon: require("@/assets/open.svg"),
      imageError: false,
      events: [],
    };
  },
  mounted() {
    this.getLastEvents();
  },
  methods: {
    updateShow(value) {
      if (!value) {
        this.close();
      }
    },
    verifyPrivilege() {
      if (!this.item) return "";

      return this.item.activeSubscription &&
        this.item.activeSubscription.isPremium
        ? "Premium"
        : this.item.creationTime &&
          this.item.creationTime.toDate() <= new Date("2021-12-07")
        ? "GrandFathered"
        : "Free";
    },
    getUserName(user) {
      if (!user) return "";

      if (user.nickname && user.nickname !== "") {
        return user.nickname;
      }
      if (user.displayName && user.displayName !== "") {
        return user.displayName;
      }
      return (
        `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
        "Unknown User"
      );
    },
    goToUserDetails() {
      if (!this.item) return;
      this.$router.push({ name: "User Profile", params: this.item });
    },
    handleImageError() {
      this.imageError = true;
      this.defaultAvatar = ""; // Clear the image source on error
    },
    copyUserData() {
      if (!this.item) return;
      const userData = JSON.stringify(this.item, null, 2);
      navigator.clipboard
        .writeText(userData)
        .then(() => {
          this.$toast.success("User data copied to clipboard");
        })
        .catch(() => {
          this.$toast.error("Failed to copy user data");
        });
    },
    getLastEvents() {
      if (this.show) {
        this.loading = true;
        if (!this.item) return;
        this.$store
          .dispatch("getEventsByUser", {
            userId: this.item.uid,
            limitNumber: 10,
          })
          .then((events) => {
            const eventsData = events.map((e) => ({
              ...e,
              user: this.item,
            }));

            this.events = eventsData;
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error in getLastEvents:', error);
            this.$toast.error("Failed to get events");
          });
      }
    },
  },
  watch: {
    show: {
      handler: function (newValue, oldValue) {
        console.log(newValue);

        this.getLastEvents();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.modal-header {
  justify-content: space-between;
  font-size: 18px;
  color: #3a3a3a;
  font-weight: bold;
}
.author-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.author-image {
  width: 64px;
  height: 64px;
  border-radius: 32px;
  object-fit: cover;
}
.author-name {
  font-size: 18px;
  font-weight: bold;
  color: #3a3a3a;
}
.open-chart-button {
  height: 16px;
  width: 16px;
  transition: all 0.2s ease-in-out;
  opacity: 0.5;
}
.open-chart-button:hover {
  cursor: pointer;
  transform: scale(1.1);
  opacity: 1;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.copy-button {
  text-transform: none;
}
</style>
